import Icon, { type IconName } from "../../atoms/Icon";

export type TabsOptionText = {
    id: string | number;
    name: string;
};

export type TabsOptionIcon = {
    id: string | number;
    /** Visible / accessible label (e.g. `aria-label`). */
    name: string;
    icon: IconName;
};

export type TabsOptionProps = TabsOptionText | TabsOptionIcon;

type TabsShared = {
    className?: string;
    classButton?: string;
    setValue: (id: string | number) => void;
};

type TabsPropsText = TabsShared & {
    isOnlyIcon?: false;
    items: TabsOptionText[];
    value: TabsOptionText;
};

type TabsPropsIcon = TabsShared & {
    isOnlyIcon: true;
    items: TabsOptionIcon[];
    value: TabsOptionIcon;
};

export type TabsProps = TabsPropsText | TabsPropsIcon;

const Tabs = (props: TabsProps) => {
    const { className, classButton, setValue } = props;

    if (props.isOnlyIcon === true) {
        const { items, value } = props;
        return (
            <div className={`flex gap-2 ${className || ""}`}>
                {items.map((item) => (
                    <button
                        type="button"
                        className={`flex h-12 w-12 items-center justify-center rounded-full border text-button transition-colors hover:text-t-primary hover:fill-t-primary ${item.id === value.id
                            ? "border-s-stroke2 fill-t-primary text-t-primary"
                            : "border-transparent fill-t-secondary text-t-secondary"
                            } ${classButton || ""}`}
                        key={item.id}
                        aria-label={item.name}
                        onClick={() => setValue(item.id)}
                    >
                        <Icon className="fill-inherit" name={item.icon} />
                    </button>
                ))}
            </div>
        );
    }

    const { items, value } = props;
    return (
        <div className={`flex gap-1 ${className || ""}`}>
            {items.map((item) => (
                <button
                    type="button"
                    className={`flex h-12 items-center justify-center rounded-full border px-5.5 text-button transition-colors hover:text-t-primary hover:fill-t-primary ${item.id === value.id
                        ? "border-s-stroke2 text-t-primary fill-t-primary"
                        : "border-transparent text-t-secondary fill-t-secondary"
                        } ${classButton || ""}`}
                    key={item.id}
                    onClick={() => setValue(item.id)}
                >
                    {item.name}
                </button>
            ))}
        </div>
    );
};

export default Tabs;
